import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';
import axios from 'axios';
//import showAlert from '../alert/alertHandler';
import moment from 'moment';
import Container from 'typedi';

/* services */
import DocumentService from '../services/DocumentService';
import ItemService from '../services/ItemService';
import RouteDetailMap from '../components/RouteDetailMap.vue';
import GoogleMapsApiLoader from 'google-maps-api-loader';
import itemTableSchema from '../resources/itemTableSchema.json';
import documentTableSchema from '../resources/documentTableSchema.json';
//import badgeStylesRoute from '../resources/badgeStylesRoute.json';
import status from '../resources/statusActivity.json';
import routeFulfillmentEscl from '../locales/es-CL/routeFulfillment.json';
import routeFulfillmentEsmx from '../locales/es-MX/routeFulfillment.json';
import routeFulfillmentEsco from '../locales/es-CO/routeFulfillment.json';
import routeFulfillmentEnus from '../locales/en-US/routeFulfillment.json';
import documentsEscl from '../locales/es-CL/documents.json';
import documentsEsmx from '../locales/es-MX/documents.json';
import documentsEsco from '../locales/es-CO/documents.json';
import documentsEnus from '../locales/en-US/documents.json';
import itemsEscl from '../locales/es-CL/items.json';
import itemsEsmx from '../locales/es-MX/items.json';
import itemsEsco from '../locales/es-CO/items.json';
import itemsEnus from '../locales/en-US/items.json';

export default {
  name: 'RouteFulfillment',
  components: {
    Multiselect,
    VueCtkDateTimePicker,
    GoogleMapsApiLoader,
    RouteDetailMap,
  },
  i18n: {
    messages: {
      'es-CL': {
        routeFulfillment: routeFulfillmentEscl,
        documents: documentsEscl,
        items: itemsEscl,
      },
      'es-MX': {
        routeFulfillment: routeFulfillmentEsmx,
        documents: documentsEsmx,
        items: itemsEsmx,
      },
      'es-CO': {
        routeFulfillment: routeFulfillmentEsco,
        documents: documentsEsco,
        items: itemsEsco,
      },
      'en-US': {
        routeFulfillment: routeFulfillmentEnus,
        documents: documentsEnus,
        items: itemsEnus,
      },
    },
  },
  data() {
    return {
      isBusy: false,
      isFilterApplied: false,
      dataAccess: null,
      shortCutPath: null,
      autoRefreshTimer: 0,
      autoRefreshTimerLimit: 300,
      refreshCountDown: 0,
      //Badges utilizados para el estado de actividad,documento,item
      badges: {
        1: {
          background: '#FFFFFF',
          color: '#03475E',
          border: '2px solid #03475E',
        },
        2: {
          background: '#FFFFFF',
          color: '#E69C21',
          border: '2px solid #E69C21',
        },
        3: {
          background: '#FFFFFF',
          color: '#C21F25',
          border: '2px solid #C21F25',
        },
        4: {
          background: '#FFFFFF',
          color: '#52A145',
          border: '2px solid #52A145',
        },
        5: {
          background: '#FFFFFF',
          color: '#E69C21',
          border: '2px solid #E69C21',
        },
      },
      optionDate: {
        minDate: null,
        maxDate: null,
      },
      statusOption: status,
      filters: {
        from: `${moment(new Date()).format('YYYY-MM-DD')} 00:00:00`,
        to: `${moment(new Date()).format('YYYY-MM-DD')} 23:59:59`,
        destinationList: [],
        plateList: [],
        nameList: [],
        nameRouteList: [],
        driverList: [],
        documentList: [],
        tags: [],
        routeIdList: [],
      },
      selected: {
        activityStatus: null,
        from: null,
        to: null,
        destination: null,
        vehicle: null,
        driver: null,
        nameRoute: null,
        routeId: null,
        activityName: null,
        documentList: null,
        tags: null,
      },
      globalStats: {
        totalAct: 0,
        totalActDone: 0,
        totalActPending: 0,
        totalActRejected: 0,
        totalActPartially: 0,
        totalActFilter: 0,
        totalActDoneFilter: 0,
        totalActPendingFilter: 0,
        totalActRejectedFilter: 0,
        totalActPartiallyFilter: 0,
      },
      totalRows: 1,
      currentPageActivities: 1,
      currentPageDocuments: 1,
      currentPageItems: 1,
      perPageActivities: 10,
      perPageDocuments: 10,
      perPageItems: 10,
      pageOptions: [10, 15, 20, 50, 100],
      isFilterShown: false,
      isFilterClicked: false,
      keywordIdRoute: '',
      activitiesFilteredData: [],
      activities: [],
      documents: [],
      itemsDetails: [],
      currentTab: 'activities',
      selectedActivity: null,
      selectedDocument: null,
      timeoutID: null,
    };
  },
  async created() {
    this.documentService = Container.get(DocumentService);
    this.itemService = Container.get(ItemService);
    let now = new Date();
    this.optionDate.minDate = moment(now.setDate(now.getDate() - 5)).format('YYYY-MM-DD');
    this.prepareData();
    this.autoRefresh();
  },
  beforeDestroy() {
    // Limpia el temporizador cuando el componente se destruya
    this.clearTimeout();
  },
  methods: {
    /**
     * Metodo que deriva a otra vista dado ciertos parametros.
     * Prioridad al cambiar de vista: Preparar filtrado instantaneo por id de ruta.
     * @param {Integer} routeId, es la id de la ruta seleccionada.
     * @param {String} path, es el nombre de la vista a la que se desea ir.
     * @returns A la nueva vista.
     */
    async goToAnotherPage(routeId, path) {
      this.isButtonClicked = true;
      await this.$store.commit('saveShortCutPathOrigin', 'Route fulfillment');
      await this.$store.commit('saveIdRouteFlash', routeId);
      return this.$router.push({ name: path });
    },
    //Metodo encargado de preparar un filtro instantaneo de la id de la ruta.
    async prepareInstantFilter() {
      this.shortCutPath = await this.$store.getters.shortCutPathOrigin;
      this.selected.routeId = this.$route.query.idRoute || (await this.$store.getters.idRouteFlash);
      this.$store.commit('cleanIdRouteFlash');
      this.$store.commit('cleanShortCutPathOrigin');
    },
    async prepareData() {
      this.dataAccess = this.$store.getters.dataAccess;
      await this.prepareInstantFilter();
      this.isBusy = true;
      await this.getActivities();
      this.populateFilters(); //Carga la lista de datos para rellenar los filtros.
      this.isBusy = false;
    },
    /**@author Nicolás Sepúlveda
     * Metodo que popula la listas de datos para los filtros.
     */
    populateFilters() {
      //Obtiene todas las id de las rutas.
      this.activities.forEach((activity) => {
        this.filters.nameRouteList.push(activity.nameRoute);
        this.filters.routeIdList.push(activity.routeId);
        this.filters.nameList.push(activity.name);
        this.filters.destinationList.push(activity.tripDestination);
        if (activity.vehicle) {
          this.filters.plateList.push(activity.vehicle.plate);
        }
        if (activity.tags) {
          this.filters.tags = this.filters.tags.concat(activity.tags);
        }

        if (activity.driver) {
          activity.driver.username =
            this.transformWords(activity.driver.firstName) + ' ' + this.transformWords(activity.driver.lastName);
          this.filters.driverList.push(activity.driver.username);
        }

        if (activity.documents) {
          for (let document of activity.documents) {
            this.filters.documentList.push(document.number);
          }
        }
      });
      //Remueve elementos repetidos del resultado.
      this.filters.destinationList = this.filters.destinationList.filter(
        (v, i, a) => a.findIndex((t) => t === v) === i,
      );
      this.filters.nameList = this.filters.nameList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.filters.nameRouteList = this.filters.nameRouteList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.filters.routeIdList = this.filters.routeIdList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.filters.plateList = this.filters.plateList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.filters.driverList = this.filters.driverList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
      this.filters.tags = this.filters.tags.filter((v, i, a) => a.findIndex((t) => t.id === v.id) === i);
      this.filters.documentList = this.filters.documentList.filter((v, i, a) => a.findIndex((t) => t === v) === i);
    },
    async getActivities() {
      const urlRoutes = `${this.$store.getters.urlAPI}/activity/fulfillment`;
      try {
        const config = {
          headers: {
            'id-client': this.$store.getters.clientId,
            Authorization: `Bearer ${this.$store.getters.accessToken}`,
          },
        };
        const result = await axios.get(urlRoutes, config);
        this.populateActivities(result.data.data);
      } catch (e) {
        console.log(e);
        return [];
      }
    },
    async loadDocuments() {
      this.keyword = '';
      this.documents = await this.documentService.getDocumentsByIdActivity(this.selectedActivity);
    },
    async loadItemsDetails() {
      this.itemsDetails = await this.itemService.getItemsByIdDocument(this.selectedDocument);
    },
    changeTab(navBar) {
      const ranking = ['activties', 'documentos', 'items'];
      const previousTabIndex = ranking.indexOf(this.currentTab);
      this.currentTab = navBar;
      const currentTabIndex = ranking.indexOf(this.currentTab);
      if (currentTabIndex > previousTabIndex) {
        this.loadByTab(navBar);
      }
    },
    async loadByTab(navBar) {
      this.isBusy = true;
      if (navBar === 'activties') {
        await this.getActivities();
      } else if (navBar === 'documentos') {
        await this.loadDocuments();
      } else if (navBar === 'items') {
        await this.loadItemsDetails();
      }
      this.isBusy = false;
    },
    populateActivities(activitiesFulfillment) {
      this.setStatsEmpty();
      this.setStatsEmptyFilter();
      this.activities = [];
      activitiesFulfillment.forEach((activity) => {
        const date = activity.startDateTrip ? new Date(activity.startDateTrip).getTime() + activity.drivingTime : null;
        this.activities.push({
          id: activity.id,
          routeId: activity.idRoute,
          nameRoute: activity.nameRoute,
          tripDestination: activity.destination
            ? `${activity.destination.street}, ${activity.destination.city}, ${activity.destination.state}`
            : null,
          startTime: date,
          dateStartTime: date ? moment(date).format('DD/MM/YY HH:mm') : '-',
          name: activity.name,
          state: activity.state,
          status: activity.status,
          vehicle: activity.vehicle ? activity.vehicle : null,
          driver: activity.driver ? activity.driver : null,
          tags: activity.tags ? activity.tags : null,
          documents: activity.documents ? activity.documents : null,
        });
        if (activity.state === 'NOTHANDLED' || activity.state === 'STARTED') {
          this.globalStats.totalActPending += 1;
          this.globalStats.totalActPendingFilter += 1;
        }
        if (activity.state === 'NOTDONE') {
          this.globalStats.totalActRejected += 1;
          this.globalStats.totalActRejectedFilter += 1;
        }
        if (activity.state === 'DONE') {
          this.globalStats.totalActDone += 1;
          this.globalStats.totalActDoneFilter += 1;
        }
        if (activity.state === 'PARTIALLYDONE') {
          this.globalStats.totalActPartially += 1;
          this.globalStats.totalActPartiallyFilter += 1;
        }
      });
      const firstAcivity = this.activities[0];
      this.optionDate.maxDate = firstAcivity.startTime ? moment(firstAcivity.startTime).format('DD/MM/YY') : '';
      this.globalStats.totalAct += this.activities.length;
      this.globalStats.totalActFilter += this.activities.length;
    },
    onActivityClicked(item, index, event) {
      this.selectedDocument = null;
      this.selectedItem = null;
      this.selectedActivity = item.id;
      this.currentPageDocument = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('documentos');
      }
    },
    onDocumentClicked(item, index, event) {
      this.selectedItem = null;
      this.selectedDocument = item.id;
      this.currentPageItem = 1;
      if (!['SVG', 'PATH'].includes(event.toUpperCase())) {
        this.changeTab('items');
      }
    },
    setStatsEmpty() {
      this.globalStats.totalAct = 0;
      this.globalStats.totalActDone = 0;
      this.globalStats.totalActRejected = 0;
      this.globalStats.totalActPending = 0;
      this.globalStats.totalActPartially = 0;
    },
    setStatsEmptyFilter() {
      this.globalStats.totalActFilter = 0;
      this.globalStats.totalActDoneFilter = 0;
      this.globalStats.totalActRejectedFilter = 0;
      this.globalStats.totalActPendingFilter = 0;
      this.globalStats.totalActPartiallyFilter = 0;
    },
    obtainPercentage(numOps) {
      if (numOps !== undefined && numOps > 0) {
        const percentage = (numOps / this.globalStats.totalActFilter) * 100;
        if (percentage < 1) {
          return percentage.toFixed(1);
        } else {
          return Math.round(percentage);
        }
      }
      return 0;
    },
    /**@author Jorge Pizarro Tapia
     * Contador que mantiene deshabilitado en boton de refresco de rutas forzado.
     */
    autoRefresh() {
      if (this.$route.name !== 'Route fulfillment') {
        return;
      }
      if (this.autoRefreshTimer <= this.autoRefreshTimerLimit) {
        this.timeoutID = setTimeout(() => {
          this.autoRefreshTimer += 1;
          this.autoRefresh();
        }, 1000);
      } else {
        this.autoRefreshTimer = 0;
        this.prepareData();
        this.autoRefresh();
      }
    },
    clearTimeout() {
      // Cancela el temporizador si está activo
      if (this.timeoutID !== null) {
        clearTimeout(this.timeoutID);
        console.log('Temporizador cancelado');
      }
    },
    limitText(count) {
      return this.$t('routeFulfillment.search.limitText') + (count + 1);
    },
    activeFilter() {
      this.isFilterShown = !this.isFilterShown;
      this.isFilterClicked = !this.isFilterClicked;
    },
    activeUseFilter() {
      this.isFilterClicked = true;
    },
    toogleFilter() {
      if (this.isFilterShown && !this.isFilterClicked) {
        this.isFilterShown = false;
      }
      if (this.isFilterClicked) {
        this.isFilterClicked = false;
      }
    },
    async handlePageChange() {
      this.isBusy = true;
      await this.getActivities();
      this.isBusy = false;
    },
    /**@author Nicolas Sepulveda
     * Metodo para transformar las palabras a capitalize,
     * Ejemplo: jOSue = Josue
     * @param {String} words
     * @returns
     */
    transformWords(words) {
      let finalWord = '';
      if (words) {
        const listWords = words.split(' ');
        listWords.forEach((word) => {
          if (word) {
            if (finalWord == '') {
              finalWord = this.capitalize(word);
            } else {
              finalWord = finalWord + ' ' + this.capitalize(word);
            }
          }
        });
      }
      return finalWord;
    },
    capitalize(word) {
      return word[0].toUpperCase() + word.slice(1).toLowerCase();
    },
    dateToSeconds(element) {
      const date = new Date(element);
      return date.getTime();
    },
  },
  computed: {
    isDocumentTabEnabled() {
      return !!this.selectedActivity;
    },
    isItemTabEnabled() {
      return !!this.selectedActivity && !!this.selectedDocument;
    },
    rows() {
      if (this.currentTab === 'activities') {
        return this.activitiesFiltered.length;
      } else if (this.currentTab === 'documentos') {
        return this.itemsDocuments.length;
      } else if (this.currentTab === 'items') {
        return this.itemsItems.length;
      }
    },
    fromManagement() {
      return !!this.$route.query.fromManagement;
    },
    itemsDocuments() {
      return this.documents.map((d) => {
        return {
          ...d,
          route: '-',
          trip: '-',
          activity: '-',
          documentNumber: d.number,
          type: this.documentService.getType(d.type) ? this.documentService.getType(d.type).value : '-',
          items: d.items ? d.items.length : 0,
          time: d.time || 0,
        };
      });
    },
    itemsItems() {
      return this.itemsDetails.map((i) => {
        return {
          ...i,
          document: i.idDocument,
          type: this.getTypeItem(i.idItemData),
          code: this.getCodeItem(i.idItemData),
          unitMeasure: i.unitMeasure || '-',
          quantity: i.quantity || '-',
          extra1: i.extra1 || '-',
          extra2: i.extra2 || '-',
          extra3: i.extra3 || '-',
          extra4: i.extra4 || '-',
          extra5: i.extra5 || '-',
        };
      });
    },
    howManyFiltersUsed() {
      let totalFiltersUsed = 0;
      if (this.filters.from !== null) {
        totalFiltersUsed += 1;
      }
      if (this.filters.to !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.activityStatus !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.destination !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.vehicle !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.driver !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.nameRoute !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.routeId !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.activityName !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.documentList !== null) {
        totalFiltersUsed += 1;
      }
      if (this.selected.tags !== null) {
        totalFiltersUsed += 1;
      }
      return totalFiltersUsed;
    },
    cleanFilter() {
      this.filters.from = null;
      this.filters.to = null;
      this.selected.activityStatus = null;
      this.selected.destination = null;
      this.selected.vehicle = null;
      this.selected.driver = null;
      this.selected.nameRoute = null;
      this.selected.routeId = null;
      this.selected.activityName = null;
      this.selected.documentList = null;
      this.selected.tags = null;
    },
    activitiesFiltered() {
      this.setStatsEmptyFilter();
      this.activitiesFilteredData = this.activities;
      this.isFilterApplied = false;
      this.currentPageActivities = 1;
      this.currentTab = 'activities';

      if (this.filters.from) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          const startDate = this.dateToSeconds(this.filters.from);
          if (activity.startTime >= startDate) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.filters.to) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          const startDate = this.dateToSeconds(this.filters.to);
          if (activity.startTime <= startDate) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.nameRoute) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (this.selected.nameRoute === activity.nameRoute) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.routeId) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (this.selected.routeId === activity.routeId) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.activityName) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (this.selected.activityName === activity.name) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.vehicle) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (activity.vehicle && this.selected.vehicle === activity.vehicle.plate) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.driver) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (activity.driver && this.selected.driver === activity.driver.username) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.destination) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (activity.tripDestination && this.selected.destination === activity.tripDestination) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.activityStatus) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (activity.status && this.selected.activityStatus.id === activity.status) {
            return activity;
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.tags && this.selected.tags.length > 0) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (activity.tags && activity.tags.length > 0) {
            return activity.tags.some((tag) => {
              return this.selected.tags.some((filterTag) => {
                if (filterTag.id === tag.id) {
                  return filterTag;
                }
              });
            });
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      if (this.selected.documentList) {
        this.activitiesFilteredData = this.activitiesFilteredData.filter((activity) => {
          if (activity.documents && activity.documents.length > 0) {
            const filteredList = activity.documents.filter(
              (document) => document.number === this.selected.documentList,
            );
            if (filteredList.length > 0) {
              return activity;
            }
          }
        });
        if (!this.isFilterApplied) {
          this.isFilterApplied = true;
        }
      }
      this.activitiesFilteredData.forEach((activity) => {
        if (activity.state === 'NOTHANDLED' || activity.state === 'STARTED') {
          this.globalStats.totalActPendingFilter += 1;
        }
        if (activity.state === 'NOTDONE') {
          this.globalStats.totalActRejectedFilter += 1;
        }
        if (activity.state === 'DONE') {
          this.globalStats.totalActDoneFilter += 1;
        }
        if (activity.state === 'PARTIALLYDONE') {
          this.globalStats.totalActPartiallyFilter += 1;
        }
      });
      this.globalStats.totalActFilter = this.activitiesFilteredData.length;
      return this.activitiesFilteredData;
    },
    fieldsDocuments() {
      const baseCell = {
        class: 'text-center',
        tdClass: 'small',
        sortable: false,
      };
      return documentTableSchema.map((e) => ({
        ...e,
        label: this.$t(e.label),
        ...baseCell,
      }));
    },
    fieldsItems() {
      const baseCell = {
        class: 'text-center',
        tdClass: 'small',
        sortable: false,
      };
      return itemTableSchema.map((e) => ({
        ...e,
        label:
          e.label.split(' ').length > 1
            ? this.$t(e.label.split(' ')[0]) + ' ' + e.label.split(' ')[1]
            : this.$t(e.label),
        ...baseCell,
      }));
    },
    activitiesAssignmentFields() {
      const common = {
        class: 'text-center',
        tdClass: 'small',
      };
      return [
        {
          key: 'routeId',
          label: this.$t('routeFulfillment.table.idRoute'),
          ...common,
        },
        {
          key: 'nameRoute',
          label: this.$t('routeFulfillment.table.nameRoute'),
          ...common,
        },
        {
          key: 'name',
          label: this.$t('routeFulfillment.table.activityName'),
          ...common,
        },
        {
          key: 'state',
          label: this.$t('routeFulfillment.table.aactivityState'),
          ...common,
        },
        {
          key: 'tags',
          label: this.$t('routeFulfillment.table.tags'),
          ...common,
        },
        {
          key: 'driver.username',
          label: this.$t('routeFulfillment.table.driver'),
          ...common,
        },
        {
          key: 'vehicle.plate',
          label: this.$t('routeFulfillment.table.vehicle'),
          ...common,
        },
        {
          key: 'tripDestination',
          label: this.$t('routeFulfillment.table.tripdestination'),
          ...common,
        },
        {
          key: 'dateStartTime',
          label: this.$t('routeFulfillment.table.dateStartTime'),
          ...common,
        },
        {
          key: 'shortcut',
          label: this.$t('routeFulfillment.table.shortcut'),
          ...common,
        },
        {
          key: 'actions',
          label: this.$t('routeFulfillment.table.actions'),
          ...common,
        },
      ];
    },
  },
};
